module.exports = __webpack_public_path__ + "roboto-v15-latin-regular.9f916e330c478bbfa2a0.eot";


//////////////////
// WEBPACK FOOTER
// C:/Disco D/Projetos/central-cliente/src/assets/vendors/ng-prime/fonts/roboto-v15-latin-regular.eot
// module id = ../../../../../src/assets/vendors/ng-prime/fonts/roboto-v15-latin-regular.eot
// module chunks = 2